module.exports = __webpack_public_path__ + "static/img/Nuvio_Primary Logo.4b5e344.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Nuvio_Primary Logo.png
// module id = 488
// module chunks = 1